module.exports = __WEBPACK_EXTERNAL_MODULE_graphql_language_parser__;